module.exports = __webpack_public_path__ + "assets/Logo_nova.710c4414.svg";